let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1lfVU")).then(() => parcelRequire('9M09V'));